import script from "./CuponesDescuentoPopUp.vue?vue&type=script&setup=true&lang=js"
export * from "./CuponesDescuentoPopUp.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCircularProgress,QCardSection,QBtn,QInput,QIcon});qInstall(script, 'directives', {ClosePopup});
